import { apiFetch } from "./apiFetch";

export async function getMyAvailability() {
  const data = await apiFetch("/api/me/availability", { method: "GET" });
  return {
    availability: Array.isArray(data?.availability) ? data.availability : [],
    blockedSlots: Array.isArray(data?.blockedSlots) ? data.blockedSlots : [],
  };
}

export async function saveMyAvailability(slots) {
  return apiFetch("/api/me/availability", {
    method: "PUT",
    body: JSON.stringify({ slots }),
  });
}

export async function blockSlot(date, time) {
  return apiFetch("/api/me/availability/block", {
    method: "POST",
    body: JSON.stringify({ date, time }),
  });
}

export async function unblockSlot(date, time) {
  return apiFetch("/api/me/availability/block", {
    method: "DELETE",
    body: JSON.stringify({ date, time }),
  });
}
